import { Component, Input, OnInit, OnDestroy, PLATFORM_ID, inject, NgZone } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

export type CarouselType = 'text' | 'word' | 'image';
export type CarouselVariant = 'section' | 'inline'; // section = con fondo propio, inline = dentro de otra sección

export interface CarouselItem {
    content: string; // Texto, palabra, o URL de imagen
    alt?: string;    // Para imágenes
}

@Component({
    selector: 'app-carousel',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './carousel.component.html',
    styleUrl: './carousel.component.scss'
})
export class CarouselComponent implements OnInit, OnDestroy {
    private platformId = inject(PLATFORM_ID);
    private ngZone = inject(NgZone);

    @Input() items: CarouselItem[] = [];
    @Input() type: CarouselType = 'text'; // 'text' (frases), 'word' (palabras grandes), 'image' (imágenes)
    @Input() variant: CarouselVariant = 'inline'; // 'section' (con fondo y padding como sección), 
    // 'inline' (solo contenido)
    @Input() interval: number = 3000; // Tiempo entre transiciones en ms
    @Input() showIndicators: boolean = true; // Puntos de navegación
    @Input() autoplay: boolean = true; // Reproducción automática
    @Input() background?: string; // Color o Degradado (solo para 'section')

    currentIndex: number = 0;
    private intervalId: any;

    ngOnInit(): void {
        if (this.autoplay && isPlatformBrowser(this.platformId)) {
            this.startAutoplay();
        }
    }

    ngOnDestroy(): void {
        this.stopAutoplay();
    }

    startAutoplay(): void {
        this.ngZone.runOutsideAngular(() => {
            this.intervalId = setInterval(() => {
                this.ngZone.run(() => {
                    this.next();
                });
            }, this.interval);
        });
    }

    stopAutoplay(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    next(): void {
        this.currentIndex = (this.currentIndex + 1) % this.items.length;
    }

    prev(): void {
        this.currentIndex = this.currentIndex === 0 ? this.items.length - 1 : this.currentIndex - 1;
    }

    goTo(index: number): void {
        this.currentIndex = index;
        // Reiniciar autoplay si estaba activo
        if (this.autoplay && isPlatformBrowser(this.platformId)) {
            this.stopAutoplay();
            this.startAutoplay();
        }
    }

    getPrevIndex(): number {
        return this.currentIndex === 0 ? this.items.length - 1 : this.currentIndex - 1;
    }
}
